@let t = text();

<div class="mind-fields__row">
  <span class="mind-fields__label">{{ t.centerLabel }}</span>
  <div class="mind-fields__chips">
    @for (option of centerOptions(); track option.center) {
      <button type="button" class="mind-fields__chip"
              [class.mind-fields__chip--active]="center() === option.center"
              [class.mind-fields__chip--muted]="!option.open"
              [title]="option.open ? t.openHint : t.definedHint"
              (click)="toggleCenter(option.center)"
              [attr.data-test-id]="'mind-center-' + option.center">
        {{ t.centerName(option.center) }}
      </button>
    }
  </div>
</div>

@if (center() && gateOptions().length > 0) {
  <div class="mind-fields__row">
    <span class="mind-fields__label">{{ t.gateLabel }}</span>
    <div class="mind-fields__chips">
      @for (option of gateOptions(); track option.gate) {
        <button type="button" class="mind-fields__chip mind-fields__chip--gate"
                [class.mind-fields__chip--active]="gate() === option.gate"
                [class.mind-fields__chip--muted]="option.ownActivated"
                [title]="option.ownActivated ? t.ownGateHint : ''"
                (click)="toggleGate(option.gate)"
                [attr.data-test-id]="'mind-gate-' + option.gate">
          {{ option.gate }}
        </button>
      }
    </div>
  </div>
}
